<template>
    <div id="adviceDutyBloc">
        <header-signature :text="adviceDuty.title" />
        <p v-if="adviceDuty.subtitle" class="lead fw-bold text-mw" v-html="adviceDuty.subtitle" />
        <div class="row">
            <div class="col-12 col-md-6 col-xl-4">
                <ob1-cards>
                    <div class="row px-3 py-1 py-md-2">
                        <variation-detail
                            :next-url="adviceDuty.selectedVariation.nextUrl"
                            :label="adviceDuty.tileTitle"
                            :banner-label="adviceDuty.selectedVariation.banner"
                            :price-block="adviceDuty.selectedVariation.priceBlockDTO"
                            :button-label="adviceDuty.selectedVariation.buttonLabel"
                            :attributes="adviceDuty.selectedVariation.attributes"
                            :contract-infos="adviceDuty.contractInfos"
                            button-track-zone="ajouter_cette_assurance"
                            button-track-nom="assurance_conseillee"
                            :button-track-cible="selectedVarationTrackCible"
                        />
                    </div>
                </ob1-cards>
            </div>
            <div class="col-12 col-md-6 col-xl-8">
                <ob1-message-alerte
                    class="pt-1 pt-md-0 text-mw"
                    :title="adviceDuty.messages.info"
                    icon="icon-info"
                    type="info"
                />
                <recommended-device-value-help
                    :title="adviceDuty.messages.title"
                    :text="adviceDuty.messages.text"
                    :picture-dto="adviceDuty.picture"
                />
            </div>
        </div>
    </div>
</template>

<script>

import HeaderSignature from "../../common/components/vue/HeaderSignature.vue";
import VariationDetail from "./VariationDetail.vue";
import RecommendedDeviceValueHelp from "./RecommendedDeviceValueHelp.vue";
import {toTmsFormat} from "./TmsUtils";

export default {
    components: {RecommendedDeviceValueHelp, VariationDetail, HeaderSignature},
    props: {
        adviceDuty: {
            type: Object,
            required: true
        }
    },
    computed: {
        selectedVarationTrackCible() {
            return toTmsFormat(this.adviceDuty.selectedVariation.label)
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'ob1_variables';

</style>
